import React from 'react';
import Styled from 'styled-components';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';
import Skeleton from '@material-ui/lab/Skeleton';
import { useEffect } from 'react';
import Applet from '../../Components/Applet';
import GridContainer from '../../Components/Grid';
import { useProfile } from '../../Contexts/UserProfileContext';
import { StyledButton } from '../../Components/Generics.styled';

const CongratulationsContainer = Styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  width: 100%;
`;

const LoginContainer = Styled.div`
width: 100%;
height: 100%;
display: flex;
align-items: center;
flex-direction: column;
`;

const WelcomeText = Styled.div`
text-align: center;
letter-spacing: 0px;
color: #343A40;
opacity: 1;
white-space: nowrap;`;

const HelpText = Styled(WelcomeText)`
font-size: 21px;
`;

const RouteButton = Styled(Button)`
background: #2e69fe 0% 0% no-repeat padding-box !important;
box-shadow: 0px 3px 3px #00000061;
border-radius: 4px;
opacity: 1;

font-weight: normal;

.MuiButton-label {
    font-weight: normal;
}
`;

const ReadyToStartContainer = Styled.div`
margin-top: 10px;
display: flex;
flex-direction: column;
align-items: center;



`;

const AccountInfoContainer = Styled.div`


`;

const AccountLabel = Styled.div`
letter-spacing: 0px;
color: #000000;
text-align: left;

`;

const AccountFields = Styled.div`
letter-spacing: 0px;
color: #000000;
text-align: left;
`;

const TellUsAboutYourBusinessSummary = () => {
    const { profile } = useProfile();
    const { advertiser, agency, parentAccount } = { ...profile };

    const accountData = agency.companyName !== null ? agency : advertiser; //if agency exists use agency else use advertiser data

    const { companyName, address } = { ...parentAccount };
    const { streetAddress1, city, stateCode, zipCode } = { ...address };
    const history = useHistory();

    const noAccountData = parentAccount === null;

    // useEffect(() => {
    //     // mutate();
    // }, []);

    return (
        <LoginContainer>
            <div>
                <WelcomeText>CONGRATULATIONS!</WelcomeText>
                <br />
                <HelpText>You are ready to start advertising!</HelpText>
                <Applet showBorder={false}>
                    <CongratulationsContainer>
                        <ReadyToStartContainer>
                            <AccountInfoContainer>
                                <AccountLabel>Account:</AccountLabel>
                                {noAccountData ? (
                                    <>
                                        <Skeleton animation="wave" />
                                        <Skeleton animation="wave" />
                                        <Skeleton animation="wave" />
                                    </>
                                ) : (
                                    <>
                                        <AccountFields>{profile.fullName}</AccountFields>
                                        <AccountFields>{`${profile.email}`}</AccountFields>
                                    </>
                                )}
                            </AccountInfoContainer>
                            <br />

                            <StyledButton
                                onClick={() => window.location.reload()}
                                variant="contained"
                                color="primary"
                            >
                                Next
                            </StyledButton>
                            {/* {error && !data ? error.reason : null} */}
                        </ReadyToStartContainer>
                    </CongratulationsContainer>
                </Applet>
            </div>
        </LoginContainer>
    );
};

export default TellUsAboutYourBusinessSummary;
